export default "__VITE_ASSET__BnuY3pz2__"